<template>

  <div class="card-curvey login-form">
    <v-form v-model="valid" >
      <h2>Welcome to BOTTER
      </h2>
      <p>Sign in to your account</p>
      <v-form v-model="valid" ref="form" class="text-xs-left mt-3">
        <Label class = "grey--text text--darken-2">Email address</Label>
        <v-text-field
          outline
          v-model="username"
          name="login"
          placeholder="EMail"
          type="text"
          flat
          :rules="[v => !!v || 'Email or user name is required']"
        ></v-text-field>
        <Label class = "grey--text text--darken-2">Password</label>
        <v-text-field
          outline
          :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          v-model="password"
          name="password"
          placeholder="Password"
          :rules="[v => !!v || 'Password is required']"
        ></v-text-field>

        <v-btn @click="login" block large  :loading="loading" color="primary" >Sign In</v-btn>
        <div class="text-center mt-4">
          <p class = "sign-up-link d-block mb-0">Don’t have an account? <span class="pointer text--primary" @click="toSignUp">Sign Up</span></p>
        </div>


      </v-form>
      <div v-if="wrongCredentials === true" class="text-xs-center white--text">Invalid User Name or
        Password
      </div>
    </v-form>
  </div>



</template>

<script>
    export default {
        data: () => ({
            username: '',
            password: '',
            valid: true,
            wrongCredentials: false,
            showPassword: false,
            loading: false
        }),
        methods: {
            login() {
                this.loading = true
                if (this.$refs.form.validate()) {
                    const store = this.$store;
                    this.$http_noauth.post('/auth/login', {
                        email: this.username,
                        password: this.password
                    })
                        .then(response => {
                            let accessToken = Math.floor((Math.random() * 100000) + 1)
                            store.dispatch('setUserToken', response.data.token)
                            store.dispatch('setUserData', response.data.user)
                            store.dispatch('setRoleId', response.data.user.role_id)
                            store.dispatch('setAccessToken', accessToken)
                            localStorage.setItem('userToken', response.data.token)
                            localStorage.setItem('userData', JSON.stringify(response.data.user))
                            localStorage.setItem('roleId', JSON.stringify(response.data.user.role_id))
                            localStorage.setItem('accessToken', accessToken)
                            window.location.href = "/"
                            this.loading = false
                        })
                        .catch(error => {
                            this.wrongCredentials = true
                            this.loading = false
                            this.$store.dispatch('setSnackbar',{
                              text: `Wrong Credentials`,
                              color: 'error'
                            })
                        });
                }
            },
            toSignUp(ev) {
                // console.log(ev)
                this.$router.push({name: 'signup'})
            },
            generateAccessToken () {

            }
        }
    }
</script>

<style lang="scss">
  .login-form {
    .v-btn__content {
      font-size: 16px !important;
    }
  }
  </style>
